import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SectionTitle = ({ children, to, right, testId }) => (
  <div className="section-title" data-testid={testId}>
    <h2>{children}</h2>
    {right}
    {to && <Link to={to} className="text-xs font-bold uppercase tracking-wider text-red-600 hover:text-red-800 inline-flex items-center gap-1 transition-colors">Voir tout <ArrowRight size={12} /></Link>}
  </div>
);
